import React, { useEffect, useState } from "react";
import { readyremit } from "../../constants/readyremit";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../types/redux";
import { PostApiData } from "../../api/general";
import { RRAuthRequest, RRAuthResponse } from "../../types/api/readyremit";
import { ROUTES } from "../../constants/api";

import Iframe from "./Iframe";
import ApiErrorModal from "../../components/Common/Modals/ApiErrorModal";
import useErrorModal from "../../hooks/useErrorModal";
import SpinningLoader from "../../components/Common/SpinningLoader";
import { SetRRAuth } from "../../actions/readyRemit";

const SDKContainer = (props) => {
  const { encryptedAuthToken, balanceCheck } = useSelector((state: RootState) => state.readyremit);
  const dispatch = useDispatch();
  const [authToken, setAuthToken] = useState<string>("");
  const openErrorModal = useErrorModal();
  const { rsp, transferMethod } = props.match.params;

  useEffect(() => {
    if (!encryptedAuthToken) {
      getRRAuth();
    } else {
      setAuthToken(encryptedAuthToken);
    }
  }, []);

  const getRRAuth = async () => {
    try {
      const url = ROUTES.READY_REMIT.AUTH;
      const response = await PostApiData<RRAuthRequest, RRAuthResponse>(url, {
        rsp,
        transferMethod
      });
      dispatch(SetRRAuth({
        rsp: response.result.rsp,
        transferMethod: response.result.transferMethod,
        encryptedAuthToken: response.result.encryptedAuthToken,
        senderId: response.result.senderId,
        balanceCheck: response.result.balanceCheck
      }));
      setAuthToken(response.result.encryptedAuthToken);
    } catch (err) {
      openErrorModal(err);
    }
  };

  return (
    <>
      <SpinningLoader show={!authToken} />

      {authToken &&
        <Iframe iframe={readyremit.iframe} rsp={rsp} transferMethod={transferMethod} token={authToken} balanceCheck={balanceCheck} />
      }

      <ApiErrorModal />
    </>

  );
}

export default SDKContainer;